/** @format */

export const langVars = {
  vi: {
    value: "vi",
    title: "VI",
  },
  en: {
    value: "en",
    title: "EN",
  },
};

export const sessionVar = {
  user: "ADMIN",
};

export const allowedRoles = ["ADMIN"];

export const path = {
  common: {
    HOME: "/",
    ABOUT: "/about",

    SERVICES: "/service",
    STRATEGY_SERVICE: "/strategy-service",
    MANAGEMENT_SERVICE: "/management-service",

    BLOG: "/blog",
    CONTACT: "/contact",
    BLOG_LIST: "/blog/:category",
    ERROR: "*",
    NOAUTH: "/not-authorize",
    BLOGDETAIL: "/detail-blog/:id",
    ABOUTLIST: "/about-list",
    PARTNERS: "/partners",
    PARTNER_DETAILS: "/partner-details/:id",
    CAREER: "/career",
    ADMIN: "/admin",
    ACTIVITY: "/activity",
    ACTIVITIY_DETAIL: "/activity-detail/:id",

    SOKO: "/soko",
  },
  private: {
    MANAGEBLOG: "/manage-blog",
    EDITBLOG: "/edit-blog",
    CREATEBLOG: "/create-blog",

    MANAGEPROJECTS: "/manage-projects",
    EDITPROJECT: "/edit-project",
    CREATEPROJECT: "/create-project",
  },
};
